import React, { useState } from 'react';
import ATMPageHeader from 'src/components/UI/atoms/ATMPageHeader/ATMPageHeader';
import ATMPagination from 'src/components/UI/atoms/ATMPagination/ATMPagination';
import ATMTable, {
  columnTypes,
} from 'src/components/UI/atoms/ATMTable/ATMTable';
import FilterDialogFormWrapper from '../FilterDialog/FilterDialogFormWrapper';

type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const RegistrationRequestsListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => { 
    const [isOpenFilter , setIsOpenFilter] = useState(false)
  return (
    <>
      <div className='flex flex-col p-4'>
        {/* Page Header */}
        <div className='p-4'>
          <ATMPageHeader
            isFilter 
          onFilterClick={()=>{setIsOpenFilter(true)}}
            pageTitle='RegistrationRequestss'
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            buttonProps={{
              btnName: 'Add New',
              onClick: () => {
                alert('Add Clicked');
              },
            }}
          />
        </div>

        {/* Table */}
        <div className='flex-1 overflow-auto flex flex-col'>
            <ATMTable
              columns={columns}
              rows={rows}
              rowExtraClasses={() => 'min-h-[40px]'}
             isLoading={isTableLoading}
            />
        </div>

        <div className='p-4 py-2'>
            <ATMPagination
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={setPage}
              onRowsPerPageChange={setRowsPerPage}
              rowCount={totalItems}
              rows={rows}
            />
          </div>
      </div>
      {isOpenFilter && <FilterDialogFormWrapper onClose={()=>{setIsOpenFilter(false)}}/>}
      </>
  );
};

export default RegistrationRequestsListing;